var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"node",staticClass:"node-item",style:(_vm.flowNodeContainer),on:{"contextmenu":function($event){$event.preventDefault();return _vm.contextmenu($event)},"mouseup":_vm.changeNodeSite}},[_c('div',{staticClass:"node-con"},[_c('i',{staticClass:"type-icon",class:_vm.iconClass}),_c('span',[_vm._v(_vm._s(_vm.node[_vm.flowMain.dataFormat.node.name]))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48cd90b4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/yz-flow/src/flowNode.vue
// module id = 16
// module chunks = 0